var map = {
	"./chart.svg": "798c",
	"./close--white.svg": "c1e0",
	"./close.svg": "bf37",
	"./external-link.svg": "6a16",
	"./group.svg": "45f3",
	"./info.svg": "07e6",
	"./keplr.svg": "95b6",
	"./loading.svg": "4045",
	"./sust.svg": "2a25",
	"./usdt.svg": "086e",
	"./ust.svg": "de1a",
	"./wallet.svg": "bc38"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";